import { gql } from "@urql/core";

export const PLAN_TEMPLATE_LIST_QUERY = gql`
  query PlanTemplateList {
    purchaseTemplates {
      nodes {
        id
        name
        templateKind
        teamId
        fiscalYear
        isActive
        steps
        approvalType
        externalWorkflow
        createdAt
        updatedAt
      }
    }
  }
`;

export const ACTIVE_PLAN_TEMPLATE_QUERY = gql`
  query ActivePlanTemplate($teamId: String, $fiscalYear: Float) {
    activePurchaseTemplate(templateKind: PLAN, teamId: $teamId, fiscalYear: $fiscalYear) {
      id
      name
      templateKind
      teamId
      fiscalYear
      isActive
      steps
      approvalType
      externalWorkflow
    }
  }
`;
